var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{ purple: _vm.data.ColorFlag == 1 }},[_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('IconCardLabCheck')],1),_c('v-col',{attrs:{"cols":"6"}},[_c('h4',[_vm._v(_vm._s(_vm.data.Test))]),_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.data.Result))]),_c('span',{staticClass:"sat"},[_vm._v("mmHG")])]),_c('v-col',{attrs:{"cols":"4"}},[_c('slider-result',{attrs:{"data":{
          max: _vm.data.MaximumValue,
          min: _vm.data.MinimumValue,
          result: _vm.data.Result,
        }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }